var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.98 0 0 8.98 0 20C0 31.02 8.98 40 20 40C31.02 40 40 31.02 40 20C40 8.98 31.02 0 20 0ZM29.56 15.4L18.22 26.74C17.94 27.02 17.56 27.18 17.16 27.18C16.76 27.18 16.38 27.02 16.1 26.74L10.44 21.08C9.86 20.5 9.86 19.54 10.44 18.96C11.02 18.38 11.98 18.38 12.56 18.96L17.16 23.56L27.44 13.28C28.02 12.7 28.98 12.7 29.56 13.28C30.14 13.86 30.14 14.8 29.56 15.4Z",
    fill: "#5CEB59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick1);
export default __webpack_public_path__ + "static/media/tick1.b6ee6058eb9d9ea46f93f7a5ec47e6b4.svg";
export { ForwardRef as ReactComponent };